/* ============================================================================
   credentialSchemas.js — Per-courier credential field-sets.
   Verbatim port from mockup renderCredentials (proship-supply-side.html §4138).
   Each field is one of:
     [label]                    → text input
     [label, 'sel', optArray]   → select
     [label, 'tog']             → toggle flag
   ========================================================================== */

export const ORDER_FMT = ['REFERENCE NUMBER', 'ORDER ID', 'AWB', 'WAYBILL']
export const LABEL_OPTS = [
  'Courier Partner Generated',
  'Seller Generated',
  'Clickpost Generated',
]
export const PICKUP_SLOTS = [
  'First Slot Always',
  'Second Slot Always',
  'Next Available Slot',
  'Custom (per pin)',
]
export const LABEL_SIZE = ['6x4', '4x6', '4x6 (thermal)', 'A4', 'A5']
export const ACCT_TYPES = [
  'Amazon Shipping Standard',
  'Amazon Shipping Premium',
  'Standard',
  'Express',
  'Economy',
]
export const AWB_GEN = ['Courier Partner Generated', 'Seller Generated']

export const SCHEMAS = {
  ATS: {
    label: 'ATS (Amazon Transportation) · Surface',
    fields: [
      ['Refresh Token'],
      ['Timezone'],
      ['Pickup Timezone'],
      ['Un Id'],
      ['Packing Group'],
      ['Pickup Slot', 'sel', PICKUP_SLOTS],
      ['Shipping Service'],
      ['Label', 'sel', LABEL_OPTS],
      ['Order Number Format', 'sel', ORDER_FMT],
      ['Label Size', 'sel', LABEL_SIZE],
      ['Activate Service Flow', 'tog'],
      ['Dangerous Goods', 'tog'],
    ],
  },
  BLITZ: {
    label: 'Blitz',
    fields: [
      ['Username'],
      ['Password'],
      ['Label', 'sel', LABEL_OPTS],
      ['Order Number Format', 'sel', ORDER_FMT],
    ],
  },
  BLUEDART: {
    label: 'BlueDart',
    fields: [
      ['License Key'],
      ['Login Id'],
      ['Api Type'],
      ['Vendor Code'],
      ['Customer Name'],
      ['Origin Area'],
      ['Prepaid Customer Code'],
      ['COD Customer Code'],
      ['Tracking License Key'],
      ['Spn Number'],
      ['Product Code'],
      ['Pack Type'],
      ['Bill Account Type'],
      ['Pdf Output Not Required'],
      ['Printer Label Size'],
      ['Otp Based Delivery'],
      ['Ndr Type'],
      ['Order Number Format', 'sel', ORDER_FMT],
      ['Require Sub Product Code', 'tog'],
      ['Is To Pay Customer', 'tog'],
      ['Register Pickup', 'tog'],
      ['Is Force Pickup', 'tog'],
      ['Enable Pre Assigned Awb Flow', 'tog'],
    ],
  },
  DELHIVERY: {
    label: 'Delhivery · Forward',
    fields: [
      ['Token'],
      ['Name'],
      ['Brand Name'],
      ['Shipping Mode'],
      ['Ndd Type'],
      ['Order Number Format', 'sel', ORDER_FMT],
      ['Label', 'sel', LABEL_OPTS],
      ['Label Size', 'sel', LABEL_SIZE],
      ['Transport Speed'],
      ['Is Otp Verified', 'tog'],
      ['Is Multi Seller Warehouse', 'tog'],
      ['Otp Based Delivery', 'tog'],
      ['Include Drop Otp', 'tog'],
    ],
  },
  DELHIVERY_REV: {
    label: 'Delhivery · Reverse',
    fields: [
      ['Token'],
      ['Name'],
      ['Shipping Mode'],
      ['Order Number Format', 'sel', ORDER_FMT],
      ['Is Multi Seller Warehouse', 'tog'],
    ],
  },
  DTDC: {
    label: 'DTDC',
    fields: [
      ['Login Id'],
      ['Password'],
      ['Manifestation Key'],
      ['Customer Code'],
      ['Commodity Id'],
      ['Tracking Key'],
      ['Ndr Username'],
      ['Ndr Password'],
      ['Bulk Serviceability Key'],
      ['Service Type'],
      ['Load Type'],
      ['Order Number Format', 'sel', ORDER_FMT],
      ['Enable Pre Assign Awb Flow', 'tog'],
    ],
  },
  EKART: {
    label: 'Ekart',
    fields: [
      ['Token'],
      ['Client Name'],
      ['Merchant Code'],
      ['Awb Series Prefix Prepaid'],
      ['Awb Series Prefix Cod'],
      ['Starting Awb Sequence'],
      ['Ending Awb Sequence'],
      ['Pod Email'],
      ['Service Type'],
      ['Tier Type'],
      ['Goods Category'],
      ['Shipping Volume'],
      ['Is Obd', 'tog'],
      ['Enable Address As Vendor Code', 'tog'],
      ['Auto Awb Series Generation', 'tog'],
    ],
  },
  ELASTICRUN: {
    label: 'ElasticRun',
    fields: [
      ['Api Key'],
      ['Api Secret'],
      ['User Id'],
      ['Org Id'],
      ['Timezone'],
      ['Awb Series Prefix'],
      ['Starting Awb Sequence'],
      ['Ending Awb Sequence'],
      ['Base Production Url'],
      ['Service Type'],
      ['Awb Flow Type'],
      ['Order Number Format', 'sel', ORDER_FMT],
    ],
  },
  PROSHIP: {
    label: 'Proship (Self)',
    fields: [
      ['Username'],
      ['Password'],
      ['Partner Id'],
      ['Channel Name'],
      ['Label', 'sel', LABEL_OPTS],
      ['Order Number Format', 'sel', ORDER_FMT],
    ],
  },
  PIKNDEL: {
    label: 'Pikndel',
    fields: [
      ['Username'],
      ['Password'],
      ['Userid'],
      ['Label', 'sel', LABEL_OPTS],
    ],
  },
  SHADOWFAX: {
    label: 'Shadowfax · Forward',
    fields: [
      ['Access Token'],
      ['Client Key'],
      ['Order Service'],
      ['Pickup Type'],
      ['Ndr Type'],
      ['Order Number Format', 'sel', ORDER_FMT],
      ['Auth Type'],
    ],
  },
  SHADOWFAX_REV: {
    label: 'Shadowfax · Reverse',
    fields: [
      ['Access Token'],
      ['Client Key'],
      ['Pickup Type'],
      ['Order Service'],
      ['Auth Type'],
    ],
  },
  XB: {
    label: 'XpressBees · Forward',
    fields: [
      ['Pickup Vendor Code'],
      ['Service Type'],
      ['Getshipmentstatus Url'],
      ['Getshipmentstatus Xb Key'],
      ['Addmanifestdetails Url'],
      ['Addmanifestdetails Xb Key'],
      ['Rtonotifyshipment Url'],
      ['Rtonotifyshipment Xb Key'],
      ['Awbnumberseriesgeneration Url'],
      ['Awbnumberseriesgeneration Xb Key'],
      ['Getawbnumbergeneratedseries Url'],
      ['Getawbnumbergeneratedseries Xb Key'],
      ['Updatendr Url'],
      ['Updatendr Xb Key'],
      ['Username'],
      ['Password'],
      ['Secret Key'],
      ['Auth Type'],
      ['Order Number Format', 'sel', ORDER_FMT],
      ['Otp Based Delivery', 'tog'],
      ['Enable Pre Assign Awb Flow', 'tog'],
    ],
  },
  XB_REV: {
    label: 'XpressBees · Reverse',
    fields: [
      ['Reverse Manifestation Url'],
      ['Reverse Manifestation Xb Key'],
      ['Reverse Shipmentstatus Url'],
      ['Reverse Shipmentstatus Xb Key'],
      ['Shipment Cancel Url'],
      ['Awbnumberseriesgeneration Url'],
      ['Getawbnumbergeneratedseries Url'],
      ['Username'],
      ['Password'],
      ['Secret Key'],
      ['Auth Type'],
      ['Order Number Format', 'sel', ORDER_FMT],
      ['Enable Pre Assign Awb Flow', 'tog'],
    ],
  },
  GENERIC: {
    label: 'Standard credentials',
    fields: [
      ['Refresh Token'],
      ['Shipping Period'],
      ['Pickup Slot', 'sel', PICKUP_SLOTS],
      ['Account Service Type', 'sel', ACCT_TYPES],
      ['Gateway Service Code'],
      ['AWB Generation', 'sel', AWB_GEN],
      ['Order Number Format', 'sel', ORDER_FMT],
      ['Label Size', 'sel', LABEL_SIZE],
      ['Dangerous Goods', 'tog'],
    ],
  },
}

/**
 * Returns true if the courier code represents a reverse / RVP service.
 * Checks serviceTypes array first, then falls back to name pattern.
 * @param {Object} c  — a DUMMY_CODES entry
 */
export function isRev(c) {
  const s = (String(c.code || '') + ' ' + String(c.display || '')).toLowerCase()
  if ((c.serviceTypes || c.svc || []).some((x) => /^rev|reverse/i.test(x))) return true
  return /reverse|_rev|rvp/.test(s)
}

/**
 * Maps a courier code object to its SCHEMAS key.
 * Matches on c.parent (courier name), applying forward/reverse split where needed.
 * Falls back to 'GENERIC'.
 * @param {Object} c  — a DUMMY_CODES entry
 * @returns {string}  — key into SCHEMAS
 */
export function schemaKey(c) {
  const p = String(c.parent || '').toLowerCase()
  const rev = isRev(c)
  if (/ats|amazon/.test(p)) return 'ATS'
  if (/blitz/.test(p)) return 'BLITZ'
  if (/blue\s*dart|bluedart/.test(p)) return 'BLUEDART'
  if (/delhivery/.test(p)) return rev ? 'DELHIVERY_REV' : 'DELHIVERY'
  if (/dtdc/.test(p)) return 'DTDC'
  if (/ekart/.test(p)) return 'EKART'
  if (/elastic/.test(p)) return 'ELASTICRUN'
  if (/proship|self/.test(p)) return 'PROSHIP'
  if (/pikndel/.test(p)) return 'PIKNDEL'
  if (/shadowfax/.test(p)) return rev ? 'SHADOWFAX_REV' : 'SHADOWFAX'
  if (/xpress|bees/.test(p)) return rev ? 'XB_REV' : 'XB'
  return 'GENERIC'
}
